import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { CategoryResponse } from "@/main/models/response";
import { SubcategoryRequest } from "@/main/models/request/subcategoryRequest";

export abstract class ISubcategoryApi {
	abstract getDomain(request: SubcategoryRequest): Promise<AxiosResponse<Result<CategoryResponse[]>>>;
}
